import { Popover } from "antd-mobile";
import { useNavigate } from "react-router";
import useUserStore from "@/stores/useUserStore";
import { callNativeApi } from "@/utils/nativeUtils";
import { useT } from "@/utils/intlUtils";
import type { Action } from "antd-mobile/es/components/popover";
import createImage from "@/assets/transfer/create.png";
import regionImage from "@/assets/transfer/region.png";
import serviceImage from "@/assets/transfer/service.png";
import standardImage from "@/assets/transfer/standard.png";

import { CreateBtn, CreateBtnImg, CreateBtnText } from "./styles";

const URL: Record<string, string> = {
  region: "/transfer/create/region",
  service: "/transfer/create/service",
  standard: "/transfer/create/standard",
};

const CreateButton = () => {
  const navigate = useNavigate();

  const { userInfo } = useUserStore();

  const t = useT();

  const actions: Action[] = [
    {
      key: "standard",
      icon: (
        <img style={{ width: 22, height: 22 }} src={standardImage} alt="" />
      ),
      text: t("标准调拨"),
    },
    {
      key: "service",
      icon: <img style={{ width: 22, height: 22 }} src={serviceImage} alt="" />,
      text: t("服务商申请调拨"),
    },
  ];

  const onAction = (e: Action) => {
    callNativeApi("hideBottom", {});
    navigate({
      pathname: URL[e.key!],
    });
  };

  // 重庆万帮，又是主企，存在自己的仓库 、 员工仓位，所以可以区域向总部申请调拨

  if (userInfo?.isMainBody === 1 && userInfo?.isServiceProvider === 1) {
    actions.push({
      key: "region",
      icon: <img style={{ width: 22, height: 22 }} src={regionImage} alt="" />,
      text: t("区域申请调拨"),
    });
  }

  return (
    <Popover.Menu
      onAction={onAction}
      actions={actions}
      placement="bottomLeft"
      trigger="click"
    >
      <CreateBtn>
        <CreateBtnImg src={createImage} />
        <CreateBtnText>{t("创建")}</CreateBtnText>
      </CreateBtn>
    </Popover.Menu>
  );
};

export default CreateButton;
